import axios from 'axios';
import apisUrls from '../urls';

const createCountryApi = (values, edit = false) => {
  const url = !edit ? apisUrls?.createCountry : apisUrls?.updateCountry;
  return axios.post(url, values, {
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  });
};

export default createCountryApi;
